// modules are defined as an array
// [ module function, map of requires ]
//
// map of requires is short require name -> numeric require
//
// anything defined in a previous bundle is accessed via the
// orig method which is the require for previous bundles

(function (
  modules,
  entry,
  mainEntry,
  parcelRequireName,
  externals,
  distDir,
  publicUrl,
  devServer
) {
  /* eslint-disable no-undef */
  var globalObject =
    typeof globalThis !== 'undefined'
      ? globalThis
      : typeof self !== 'undefined'
      ? self
      : typeof window !== 'undefined'
      ? window
      : typeof global !== 'undefined'
      ? global
      : {};
  /* eslint-enable no-undef */

  // Save the require from previous bundle to this closure if any
  var previousRequire =
    typeof globalObject[parcelRequireName] === 'function' &&
    globalObject[parcelRequireName];

  var importMap = previousRequire.i || {};
  var cache = previousRequire.cache || {};
  // Do not use `require` to prevent Webpack from trying to bundle this call
  var nodeRequire =
    typeof module !== 'undefined' &&
    typeof module.require === 'function' &&
    module.require.bind(module);

  function newRequire(name, jumped) {
    if (!cache[name]) {
      if (!modules[name]) {
        if (externals[name]) {
          return externals[name];
        }
        // if we cannot find the module within our internal map or
        // cache jump to the current global require ie. the last bundle
        // that was added to the page.
        var currentRequire =
          typeof globalObject[parcelRequireName] === 'function' &&
          globalObject[parcelRequireName];
        if (!jumped && currentRequire) {
          return currentRequire(name, true);
        }

        // If there are other bundles on this page the require from the
        // previous one is saved to 'previousRequire'. Repeat this as
        // many times as there are bundles until the module is found or
        // we exhaust the require chain.
        if (previousRequire) {
          return previousRequire(name, true);
        }

        // Try the node require function if it exists.
        if (nodeRequire && typeof name === 'string') {
          return nodeRequire(name);
        }

        var err = new Error("Cannot find module '" + name + "'");
        err.code = 'MODULE_NOT_FOUND';
        throw err;
      }

      localRequire.resolve = resolve;
      localRequire.cache = {};

      var module = (cache[name] = new newRequire.Module(name));

      modules[name][0].call(
        module.exports,
        localRequire,
        module,
        module.exports,
        globalObject
      );
    }

    return cache[name].exports;

    function localRequire(x) {
      var res = localRequire.resolve(x);
      if (res === false) {
        return {};
      }
      // Synthesize a module to follow re-exports.
      if (Array.isArray(res)) {
        var m = {__esModule: true};
        res.forEach(function (v) {
          var key = v[0];
          var id = v[1];
          var exp = v[2] || v[0];
          var x = newRequire(id);
          if (key === '*') {
            Object.keys(x).forEach(function (key) {
              if (
                key === 'default' ||
                key === '__esModule' ||
                Object.prototype.hasOwnProperty.call(m, key)
              ) {
                return;
              }

              Object.defineProperty(m, key, {
                enumerable: true,
                get: function () {
                  return x[key];
                },
              });
            });
          } else if (exp === '*') {
            Object.defineProperty(m, key, {
              enumerable: true,
              value: x,
            });
          } else {
            Object.defineProperty(m, key, {
              enumerable: true,
              get: function () {
                if (exp === 'default') {
                  return x.__esModule ? x.default : x;
                }
                return x[exp];
              },
            });
          }
        });
        return m;
      }
      return newRequire(res);
    }

    function resolve(x) {
      var id = modules[name][1][x];
      return id != null ? id : x;
    }
  }

  function Module(moduleName) {
    this.id = moduleName;
    this.bundle = newRequire;
    this.require = nodeRequire;
    this.exports = {};
  }

  newRequire.isParcelRequire = true;
  newRequire.Module = Module;
  newRequire.modules = modules;
  newRequire.cache = cache;
  newRequire.parent = previousRequire;
  newRequire.distDir = distDir;
  newRequire.publicUrl = publicUrl;
  newRequire.devServer = devServer;
  newRequire.i = importMap;
  newRequire.register = function (id, exports) {
    modules[id] = [
      function (require, module) {
        module.exports = exports;
      },
      {},
    ];
  };

  // Only insert newRequire.load when it is actually used.
  // The code in this file is linted against ES5, so dynamic import is not allowed.
  // INSERT_LOAD_HERE

  Object.defineProperty(newRequire, 'root', {
    get: function () {
      return globalObject[parcelRequireName];
    },
  });

  globalObject[parcelRequireName] = newRequire;

  for (var i = 0; i < entry.length; i++) {
    newRequire(entry[i]);
  }

  if (mainEntry) {
    // Expose entry point to Node, AMD or browser globals
    // Based on https://github.com/ForbesLindesay/umd/blob/master/template.js
    var mainExports = newRequire(mainEntry);

    // CommonJS
    if (typeof exports === 'object' && typeof module !== 'undefined') {
      module.exports = mainExports;

      // RequireJS
    } else if (typeof define === 'function' && define.amd) {
      define(function () {
        return mainExports;
      });
    }
  }
})({"dwOW5":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DatePickerContext", ()=>DatePickerContext);
parcelHelpers.export(exports, "timeField", ()=>timeField);
parcelHelpers.export(exports, "DatePicker", ()=>DatePicker);
parcelHelpers.export(exports, "CalendarPopover", ()=>CalendarPopover);
parcelHelpers.export(exports, "CalendarButton", ()=>CalendarButton);
var _jsxRuntime = require("react/jsx-runtime");
var _datePicker = require("react-aria-components/DatePicker");
var _button = require("react-aria-components/Button");
var _calendar = require("./Calendar");
var _s2IconCalendar20NSvg = require("../s2wf-icons/S2_Icon_Calendar_20_N.svg");
var _s2IconCalendar20NSvgDefault = parcelHelpers.interopDefault(_s2IconCalendar20NSvg);
var _slots = require("react-aria-components/slots");
var _react = require("react");
var _dateField = require("./DateField");
var _dialog = require("react-aria-components/Dialog");
var _field = require("./Field");
var _form = require("react-aria-components/Form");
var _icon = require("./Icon");
var _json = require("../intl/*.json");
var _jsonDefault = parcelHelpers.interopDefault(_json);
var _popover = require("./Popover");
var _pressScale = require("./pressScale");
var _timeField = require("./TimeField");
var _useLocalizedStringFormatter = require("react-aria/useLocalizedStringFormatter");
var _useSpectrumContextProps = require("./useSpectrumContextProps");
const DatePickerContext = /*#__PURE__*/ (0, _react.createContext)(null);
const inputButton = function anonymous(props) {
    let rules = " ";
    if (props.isFocusVisible) rules += ' _Lf18';
    else rules += ' _Le18';
    rules += ' Oh18';
    rules += ' OlOVIhfcebS7sd18';
    rules += ' OlOVIhfcebS7sd18';
    rules += ' _Mc18';
    rules += ' _Kd18';
    if (props.size === "XL") rules += ' -SFnbic-_JaP8ec18';
    else if (props.size === "L") rules += ' -SFnbic-_J0K2hn18';
    else if (props.size === "S") rules += ' -SFnbic-_JJOW22b18';
    else if (props.size === "XS") rules += ' -SFnbic-_JICefdd18';
    else rules += ' -SFnbic-_Jb18';
    rules += ' -Bu7z1c-oR3ltQc18';
    rules += ' oj18';
    rules += ' nj18';
    rules += ' kj18';
    rules += ' jj18';
    rules += ' _Pc18';
    if (props.size === "XL") {
        rules += ' uk18';
        rules += ' ucJ9TBTb18';
        rules += ' ud3Euai18';
        rules += ' uea18';
        rules += ' ugb18';
        rules += ' uhd18';
        rules += ' uje18';
        rules += ' u2NhKxcl18';
        rules += ' uic18';
    } else if (props.size === "L") {
        rules += ' uk18';
        rules += ' ucJ9TBTb18';
        rules += ' ud3Euai18';
        rules += ' uea18';
        rules += ' ugb18';
        rules += ' uhd18';
        rules += ' uje18';
        rules += ' u2NhKxcl18';
        rules += ' uic18';
    } else if (props.size === "M") {
        rules += ' uk18';
        rules += ' ucJ9TBTb18';
        rules += ' ud3Euai18';
        rules += ' uea18';
        rules += ' ugb18';
        rules += ' uhd18';
        rules += ' uje18';
        rules += ' u2NhKxcl18';
        rules += ' uic18';
    } else if (props.size === "S") {
        rules += ' uk18';
        rules += ' ucJ9TBTb18';
        rules += ' ud3Euai18';
        rules += ' uea18';
        rules += ' ugb18';
        rules += ' uhd18';
        rules += ' uje18';
        rules += ' u2NhKxcl18';
        rules += ' uic18';
    }
    if (props.size === "XL") {
        rules += ' -_6BNtrc-e18';
        rules += ' vFHT6Dd18';
    } else if (props.size === "L") {
        rules += ' -_6BNtrc-d18';
        rules += ' vFHT6Dd18';
    } else if (props.size === "M") {
        rules += ' -_6BNtrc-c18';
        rules += ' vFHT6Dd18';
    } else if (props.size === "S") {
        rules += ' -_6BNtrc-b18';
        rules += ' vFHT6Dd18';
    }
    if (props.size === "XL") {
        rules += ' xb18';
        rules += ' _xa18';
    } else if (props.size === "L") {
        rules += ' xb18';
        rules += ' _xa18';
    } else if (props.size === "M") {
        rules += ' xb18';
        rules += ' _xa18';
    } else if (props.size === "S") {
        rules += ' xb18';
        rules += ' _xa18';
    }
    if (props.size === "XL") {
        rules += ' _Fd18';
        rules += ' _FnuYUweb18';
    } else if (props.size === "L") {
        rules += ' _Fd18';
        rules += ' _FnuYUweb18';
    } else if (props.size === "M") {
        rules += ' _Fd18';
        rules += ' _FnuYUweb18';
    } else if (props.size === "S") {
        rules += ' _Fd18';
        rules += ' _FnuYUweb18';
    }
    if (props.isDisabled) rules += ' pp18';
    else {
        if (props.isPressed) rules += ' po18';
        else if (props.isFocusVisible) rules += ' po18';
        else if (props.isHovered) rules += ' po18';
        else rules += ' pt18';
    }
    rules += ' plOVIhfc8qxrJ18';
    rules += ' plOVIhfc8qxrJ18';
    rules += ' ri18';
    rules += ' sd18';
    rules += ' _Wa18';
    rules += ' _je18';
    rules += ' eb18';
    rules += ' _Ca18';
    if (props.size === "XL") rules += ' Z4dY0ec18';
    else if (props.size === "L") rules += ' ZCe2o8c18';
    else if (props.size === "M") rules += ' ZifsFYc18';
    else if (props.size === "S") rules += ' ZxhYlec18';
    rules += ' Fd18';
    rules += ' Iw18';
    rules += ' fa18';
    rules += ' _va18';
    rules += ' Yd18';
    rules += ' YlOVIhfce18';
    rules += ' YlOVIhfce18';
    rules += ' Xb18';
    rules += ' XlOVIhfcb18';
    rules += ' XlOVIhfcb18';
    rules += ' _2b18';
    rules += ' _2lOVIhfcb18';
    rules += ' _2lOVIhfcb18';
    if (props.isDisabled) rules += ' gH18';
    else if (props.isOpen) rules += ' gF18';
    else {
        if (props.isPressed) rules += ' gF18';
        else if (props.isFocusVisible) rules += ' gF18';
        else if (props.isHovered) rules += ' gF18';
        else rules += ' gH18';
    }
    if (props.isDisabled) rules += ' glOVIhfcYMPQu18';
    else if (props.isOpen) rules += ' glOVIhfcebS7sd18';
    else if (props.isHovered) rules += ' glOVIhfcebS7sd18';
    else rules += ' glOVIhfc6LxY918';
    if (props.isDisabled) rules += ' glOVIhfcYMPQu18';
    else if (props.isOpen) rules += ' glOVIhfcebS7sd18';
    else if (props.isHovered) rules += ' glOVIhfcebS7sd18';
    else rules += ' glOVIhfc6LxY918';
    return rules;
};
const timeField = " _vb18 _ua18 Na18 Ze4mUs18";
const DatePicker = /*#__PURE__*/ (0, _react.forwardRef)(function DatePicker(props1, ref) {
    [props1, ref] = (0, _useSpectrumContextProps.useSpectrumContextProps)(props1, ref, DatePickerContext);
    let stringFormatter = (0, _useLocalizedStringFormatter.useLocalizedStringFormatter)((0, _jsonDefault.default), '@react-spectrum/s2');
    let { label, contextualHelp, description: descriptionMessage, errorMessage, isRequired, size = 'M', labelPosition = 'top', necessityIndicator, labelAlign = 'start', UNSAFE_style, UNSAFE_className, styles, placeholderValue, maxVisibleMonths = 1, createCalendar, ...dateFieldProps } = props1;
    let formContext = (0, _react.useContext)((0, _form.FormContext));
    let [buttonHasFocus, setButtonHasFocus] = (0, _react.useState)(false);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _datePicker.DatePicker), {
        ref: ref,
        isRequired: isRequired,
        ...dateFieldProps,
        style: UNSAFE_style,
        className: (UNSAFE_className || '') + function anonymous(props, overrides) {
            let rules = " ";
            let gridColumnStart = false;
            let gridColumnEnd = false;
            let matches = String(overrides || '').matchAll(/(?:^|\s)(J|G|I|H|_u|_v|_s|__A|_d|_J|z|y|B|A|_P|_9|W|_l|_A|_z|_6|Z|N|L)[^\s]+/g);
            for (let p of matches){
                if (p[1] === "z") gridColumnStart = true;
                if (p[1] === "y") gridColumnEnd = true;
                rules += p[0];
            }
            rules += ' se18';
            if (props.isInForm) {
                if (!gridColumnStart) rules += ' z2mU18';
            }
            if (props.isInForm) {
                if (props.labelPosition === "side") {
                    if (!gridColumnEnd) rules += ' yvoofG18';
                }
            }
            if (props.isInForm) rules += ' DLwlgod18';
            else {
                if (props.labelPosition === "side") rules += ' DPlN5qb18';
                else if (props.labelPosition === "top") rules += ' DM8Mfn18';
            }
            if (props.labelPosition === "side") rules += ' EPlN5qb18';
            else if (props.labelPosition === "top") rules += ' E4w1sLc18';
            if (props.labelPosition === "side") rules += ' CbRM95c18';
            else if (props.labelPosition === "top") rules += ' Cxaocre18';
            if (props.size === "XL") {
                rules += ' -_6BNtrc-e18';
                rules += ' vFHT6Dd18';
            } else if (props.size === "L") {
                rules += ' -_6BNtrc-d18';
                rules += ' vFHT6Dd18';
            } else if (props.size === "S") {
                rules += ' -_6BNtrc-b18';
                rules += ' vFHT6Dd18';
            } else if (props.size === "XS") {
                rules += ' -_6BNtrc-a18';
                rules += ' vFHT6Dd18';
            } else {
                rules += ' -_6BNtrc-c18';
                rules += ' vFHT6Dd18';
            }
            rules += ' ea18';
            rules += ' _Fd18';
            rules += ' _FnuYUweb18';
            if (props.size === "XL") rules += ' -BhX7R-FBaYFfc18';
            else if (props.size === "L") rules += ' -BhX7R-F3JjxG18';
            else if (props.size === "S") rules += ' -BhX7R-FCe2o8c18';
            else if (props.size === "XS") rules += ' -BhX7R-FifsFYc18';
            else rules += ' -BhX7R-F4dY0ec18';
            rules += ' -AJjOLd-UVkF0Db18';
            rules += ' qi9a9Xd18';
            rules += ' __ca18';
            return rules;
        }({
            isInForm: !!formContext,
            labelPosition,
            size
        }, styles),
        children: ({ isDisabled, isInvalid, isOpen, state })=>{
            let placeholder = placeholderValue ?? undefined;
            let timePlaceholder = placeholder && 'hour' in placeholder ? placeholder : undefined;
            let timeMinValue = props1.minValue && 'hour' in props1.minValue ? props1.minValue : undefined;
            let timeMaxValue = props1.maxValue && 'hour' in props1.maxValue ? props1.maxValue : undefined;
            let timeGranularity = state.granularity === 'hour' || state.granularity === 'minute' || state.granularity === 'second' ? state.granularity : undefined;
            let showTimeField = !!timeGranularity;
            // Ideally, we could omit errorMessage here and let S2 Calendar read it from RAC's CalendarContext which already contains the resolved value via calendarProps from useDatePicker.
            // However, RAC's CalendarProps omits errorMessage, so reading it back from the context would require an unsafe cast. Instead, we resolve it here using the same logic as useDatePicker.
            let resolvedErrorMessage = typeof errorMessage === 'function' ? errorMessage(state.displayValidation) : errorMessage || state.displayValidation.validationErrors.join(' ');
            return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _field.FieldLabel), {
                        isDisabled: isDisabled,
                        isRequired: isRequired,
                        size: size,
                        labelPosition: labelPosition,
                        labelAlign: labelAlign,
                        necessityIndicator: necessityIndicator,
                        contextualHelp: contextualHelp,
                        children: label
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _field.FieldGroup), {
                        role: "presentation",
                        shouldTurnOffFocusRing: buttonHasFocus,
                        isDisabled: isDisabled,
                        isInvalid: isInvalid,
                        size: size,
                        styles: function anonymous(props) {
                            let rules = " ";
                            rules += ' zXcEWr18';
                            rules += ' yXcEWr18';
                            rules += ' BXcEWr18';
                            rules += ' AXcEWr18';
                            if (props.size === "XL") rules += ' NBaYFfc18';
                            else if (props.size === "L") rules += ' N3JjxG18';
                            else if (props.size === "S") rules += ' NCe2o8c18';
                            else if (props.size === "XS") rules += ' NifsFYc18';
                            else rules += ' N4dY0ec18';
                            if (props.isQuiet) rules += ' _qd18';
                            else rules += ' _qtb18';
                            if (props.size === "XL") rules += ' -Anxdcc-ZIqJukc18';
                            else if (props.size === "L") rules += ' -Anxdcc-ZbuJPjc18';
                            else if (props.size === "S") rules += ' -Anxdcc-Z7AJvic18';
                            else rules += ' -Anxdcc-ZExJajc18';
                            rules += ' __v6TNLWb18';
                            rules += ' __Wb18';
                            rules += ' SMBFGYc18';
                            rules += ' RfBFGYc18';
                            rules += ' -S_-Sv18';
                            if (props.size === "XL") rules += ' -R_-RbCyY5d18';
                            else if (props.size === "L") rules += ' -R_-RbCyY5d18';
                            else if (props.size === "M") rules += ' -R_-Rp18';
                            else if (props.size === "S") rules += ' -R_-Rj18';
                            return rules;
                        }({
                            size
                        }),
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dateField.DateInputContainer), {
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dateField.DateInput), {})
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dateField.InvalidIndicator), {
                                isInvalid: isInvalid,
                                isDisabled: isDisabled
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(CalendarButton, {
                                isOpen: isOpen,
                                size: size,
                                setButtonHasFocus: setButtonHasFocus
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(CalendarPopover, {
                        shouldFlip: props1.shouldFlip,
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _calendar.Calendar), {
                                visibleMonths: maxVisibleMonths,
                                createCalendar: createCalendar,
                                errorMessage: resolvedErrorMessage
                            }),
                            showTimeField && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: " sd18 UB1JKEb18 qB1JKEb18 _qb18",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _timeField.TimeField), {
                                    styles: timeField,
                                    label: stringFormatter.format('datepicker.time'),
                                    value: state.timeValue,
                                    // TODO: why do i need the cast?
                                    onChange: (v)=>state.setTimeValue(v),
                                    placeholderValue: timePlaceholder,
                                    granularity: timeGranularity,
                                    minValue: timeMinValue,
                                    maxValue: timeMaxValue,
                                    hourCycle: props1.hourCycle,
                                    hideTimeZone: props1.hideTimeZone
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _field.HelpText), {
                        size: size,
                        isDisabled: isDisabled,
                        isInvalid: isInvalid,
                        description: descriptionMessage,
                        children: resolvedErrorMessage
                    })
                ]
            });
        }
    });
});
function CalendarPopover(props) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _popover.Popover), {
        ...props,
        hideArrow: true,
        padding: "none",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
            className: " Sf18 Rf18 Th18 Qh18 _Na18 Pa18 sd18 _ta18 UB1JKEb18 qB1JKEb18 _oa18 Za18 Fb18",
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dialog.Dialog), {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _slots.Provider), {
                    values: [
                        [
                            (0, _dialog.OverlayTriggerStateContext),
                            null
                        ]
                    ],
                    children: props.children
                })
            })
        })
    });
}
function CalendarButton(props) {
    let buttonRef = (0, _react.useRef)(null);
    let { isOpen, size, setButtonHasFocus } = props;
    // oxlint-disable react/react-compiler
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _button.Button), {
        ref: buttonRef,
        // Prevent press scale from sticking while DatePicker is open.
        // @ts-ignore
        isPressed: false,
        onFocusChange: setButtonHasFocus,
        style: (0, _pressScale.pressScale)(buttonRef),
        className: (renderProps)=>inputButton({
                ...renderProps,
                size,
                isOpen
            }),
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _slots.Provider), {
            values: [
                [
                    (0, _icon.IconContext),
                    {
                        styles: " -_8sjo0b-t5ZbAob18 Za8Mfn18 Fa8Mfn18"
                    }
                ]
            ],
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2IconCalendar20NSvgDefault.default), {})
        })
    });
// oxlint-enable react/react-compiler
}

},{"0":"jLzk4","1":"hf5oE","2":"byg59","3":"aoXE5","4":"bCVQR","5":"roLFs","6":"lQZ5V","react/jsx-runtime":"2Is6Z","react-aria-components/DatePicker":"59rph","react-aria-components/Button":"9G5XO","./Calendar":"j5ASf","../s2wf-icons/S2_Icon_Calendar_20_N.svg":"3yrCq","react-aria-components/slots":"bA6Cz","react":"a1TxN","./DateField":"l2Cjd","react-aria-components/Dialog":"l2uUY","./Field":"eI7CE","react-aria-components/Form":"g7RKA","./Icon":"jQAJE","../intl/*.json":"gDH3q","./Popover":"62puW","./pressScale":"8Ufux","./TimeField":"jK89c","react-aria/useLocalizedStringFormatter":"4LM0k","./useSpectrumContextProps":"8SU0q","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"jLzk4":[function() {},{}],"hf5oE":[function() {},{}],"byg59":[function() {},{}],"aoXE5":[function() {},{}],"bCVQR":[function() {},{}],"roLFs":[function() {},{}],"lQZ5V":[function() {},{}],"59rph":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2022 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DatePickerContext", ()=>DatePickerContext);
parcelHelpers.export(exports, "DateRangePickerContext", ()=>DateRangePickerContext);
parcelHelpers.export(exports, "DatePickerStateContext", ()=>DatePickerStateContext);
parcelHelpers.export(exports, "DateRangePickerStateContext", ()=>DateRangePickerStateContext);
parcelHelpers.export(exports, "DatePicker", ()=>DatePicker);
parcelHelpers.export(exports, "DateRangePicker", ()=>DateRangePicker);
var _useDatePicker = require("react-aria/useDatePicker");
var _useDateRangePicker = require("react-aria/useDateRangePicker");
var _button = require("./Button");
var _calendar = require("./Calendar");
var _utils = require("./utils");
var _dateField = require("./DateField");
var _useDatePickerState = require("react-stately/useDatePickerState");
var _useDateRangePickerState = require("react-stately/useDateRangePickerState");
var _dialog = require("./Dialog");
var _fieldError = require("./FieldError");
var _filterDOMProps = require("react-aria/filterDOMProps");
var _form = require("./Form");
var _group = require("./Group");
var _hiddenDateInput = require("./HiddenDateInput");
var _label = require("./Label");
var _mergeProps = require("react-aria/mergeProps");
var _popover = require("./Popover");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _text = require("./Text");
var _useFocusRing = require("react-aria/useFocusRing");
const DatePickerContext = /*#__PURE__*/ (0, _react.createContext)(null);
const DateRangePickerContext = /*#__PURE__*/ (0, _react.createContext)(null);
const DatePickerStateContext = /*#__PURE__*/ (0, _react.createContext)(null);
const DateRangePickerStateContext = /*#__PURE__*/ (0, _react.createContext)(null);
// Contexts to clear inside the popover.
const CLEAR_CONTEXTS = [
    (0, _group.GroupContext),
    (0, _button.ButtonContext),
    (0, _label.LabelContext),
    (0, _text.TextContext)
];
const DatePicker = /*#__PURE__*/ (0, _react.forwardRef)(function DatePicker(props, ref) {
    [props, ref] = (0, _utils.useContextProps)(props, ref, DatePickerContext);
    let { validationBehavior: formValidationBehavior } = (0, _utils.useSlottedContext)((0, _form.FormContext)) || {};
    let validationBehavior = props.validationBehavior ?? formValidationBehavior ?? 'native';
    let state = (0, _useDatePickerState.useDatePickerState)({
        ...props,
        validationBehavior
    });
    let groupRef = (0, _react.useRef)(null);
    let [labelRef, label] = (0, _utils.useSlot)(!props['aria-label'] && !props['aria-labelledby']);
    let { groupProps, labelProps, fieldProps, buttonProps, dialogProps, calendarProps, descriptionProps, errorMessageProps, ...validation } = (0, _useDatePicker.useDatePicker)({
        ...(0, _utils.removeDataAttributes)(props),
        label,
        validationBehavior
    }, state, groupRef);
    let { focusProps, isFocused, isFocusVisible } = (0, _useFocusRing.useFocusRing)({
        within: true
    });
    let renderProps = (0, _utils.useRenderProps)({
        ...props,
        values: {
            state,
            isFocusWithin: isFocused,
            isFocusVisible,
            isDisabled: props.isDisabled || false,
            isInvalid: state.isInvalid,
            isOpen: state.isOpen,
            isReadOnly: props.isReadOnly || false,
            isRequired: props.isRequired || false
        },
        defaultClassName: 'react-aria-DatePicker'
    });
    let DOMProps = (0, _filterDOMProps.filterDOMProps)(props, {
        global: true
    });
    delete DOMProps.id;
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _utils.Provider), {
        values: [
            [
                DatePickerStateContext,
                state
            ],
            [
                (0, _group.GroupContext),
                {
                    ...groupProps,
                    ref: groupRef,
                    isInvalid: state.isInvalid
                }
            ],
            [
                (0, _dateField.DateFieldContext),
                fieldProps
            ],
            [
                (0, _button.ButtonContext),
                {
                    ...buttonProps,
                    isPressed: state.isOpen
                }
            ],
            [
                (0, _label.LabelContext),
                {
                    ...labelProps,
                    ref: labelRef,
                    elementType: 'span'
                }
            ],
            [
                (0, _calendar.CalendarContext),
                calendarProps
            ],
            [
                (0, _dialog.OverlayTriggerStateContext),
                state
            ],
            [
                (0, _popover.PopoverContext),
                {
                    trigger: 'DatePicker',
                    triggerRef: groupRef,
                    placement: 'bottom start',
                    clearContexts: CLEAR_CONTEXTS
                }
            ],
            [
                (0, _dialog.DialogContext),
                dialogProps
            ],
            [
                (0, _text.TextContext),
                {
                    slots: {
                        description: descriptionProps,
                        errorMessage: errorMessageProps
                    }
                }
            ],
            [
                (0, _fieldError.FieldErrorContext),
                validation
            ]
        ]
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _utils.dom).div, {
        ...(0, _mergeProps.mergeProps)(DOMProps, renderProps, focusProps),
        ref: ref,
        slot: props.slot || undefined,
        "data-focus-within": isFocused || undefined,
        "data-invalid": state.isInvalid || undefined,
        "data-focus-visible": isFocusVisible || undefined,
        "data-disabled": props.isDisabled || undefined,
        "data-readonly": props.isReadOnly || undefined,
        "data-required": props.isRequired || undefined,
        "data-open": state.isOpen || undefined
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _hiddenDateInput.HiddenDateInput), {
        autoComplete: props.autoComplete,
        name: props.name,
        isDisabled: props.isDisabled,
        state: state
    }));
});
const DateRangePicker = /*#__PURE__*/ (0, _react.forwardRef)(function DateRangePicker(props, ref) {
    [props, ref] = (0, _utils.useContextProps)(props, ref, DateRangePickerContext);
    let { validationBehavior: formValidationBehavior } = (0, _utils.useSlottedContext)((0, _form.FormContext)) || {};
    let validationBehavior = props.validationBehavior ?? formValidationBehavior ?? 'native';
    let state = (0, _useDateRangePickerState.useDateRangePickerState)({
        ...props,
        validationBehavior
    });
    let groupRef = (0, _react.useRef)(null);
    let [labelRef, label] = (0, _utils.useSlot)(!props['aria-label'] && !props['aria-labelledby']);
    let { groupProps, labelProps, startFieldProps, endFieldProps, buttonProps, dialogProps, calendarProps, descriptionProps, errorMessageProps, ...validation } = (0, _useDateRangePicker.useDateRangePicker)({
        ...(0, _utils.removeDataAttributes)(props),
        label,
        validationBehavior
    }, state, groupRef);
    let { focusProps, isFocused, isFocusVisible } = (0, _useFocusRing.useFocusRing)({
        within: true
    });
    let renderProps = (0, _utils.useRenderProps)({
        ...props,
        values: {
            state,
            isFocusWithin: isFocused,
            isFocusVisible,
            isDisabled: props.isDisabled || false,
            isInvalid: state.isInvalid,
            isOpen: state.isOpen,
            isReadOnly: props.isReadOnly || false,
            isRequired: props.isRequired || false
        },
        defaultClassName: 'react-aria-DateRangePicker'
    });
    let DOMProps = (0, _filterDOMProps.filterDOMProps)(props, {
        global: true
    });
    delete DOMProps.id;
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _utils.Provider), {
        values: [
            [
                DateRangePickerStateContext,
                state
            ],
            [
                (0, _group.GroupContext),
                {
                    ...groupProps,
                    ref: groupRef,
                    isInvalid: state.isInvalid
                }
            ],
            [
                (0, _button.ButtonContext),
                {
                    ...buttonProps,
                    isPressed: state.isOpen
                }
            ],
            [
                (0, _label.LabelContext),
                {
                    ...labelProps,
                    ref: labelRef,
                    elementType: 'span'
                }
            ],
            [
                (0, _calendar.RangeCalendarContext),
                calendarProps
            ],
            [
                (0, _dialog.OverlayTriggerStateContext),
                state
            ],
            [
                (0, _popover.PopoverContext),
                {
                    trigger: 'DateRangePicker',
                    triggerRef: groupRef,
                    placement: 'bottom start',
                    clearContexts: CLEAR_CONTEXTS
                }
            ],
            [
                (0, _dialog.DialogContext),
                dialogProps
            ],
            [
                (0, _dateField.DateFieldContext),
                {
                    slots: {
                        start: startFieldProps,
                        end: endFieldProps
                    }
                }
            ],
            [
                (0, _text.TextContext),
                {
                    slots: {
                        description: descriptionProps,
                        errorMessage: errorMessageProps
                    }
                }
            ],
            [
                (0, _fieldError.FieldErrorContext),
                validation
            ]
        ]
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _utils.dom).div, {
        ...(0, _mergeProps.mergeProps)(DOMProps, renderProps, focusProps),
        ref: ref,
        slot: props.slot || undefined,
        "data-focus-within": isFocused || undefined,
        "data-invalid": state.isInvalid || undefined,
        "data-focus-visible": isFocusVisible || undefined,
        "data-disabled": props.isDisabled || undefined,
        "data-readonly": props.isReadOnly || undefined,
        "data-required": props.isRequired || undefined,
        "data-open": state.isOpen || undefined
    }));
});

},{"react-aria/useDatePicker":"cRr2p","react-aria/useDateRangePicker":"bYH2k","./Button":"9G5XO","./Calendar":"2DleA","./utils":"bA6Cz","./DateField":"5wv9P","react-stately/useDatePickerState":"leLOt","react-stately/useDateRangePickerState":"iJMKi","./Dialog":"l2uUY","./FieldError":"algyu","react-aria/filterDOMProps":"c0Owd","./Form":"g7RKA","./Group":"6UspO","./HiddenDateInput":"k88K4","./Label":"fjKq6","react-aria/mergeProps":"1CzGd","./Popover":"l4JC0","react":"a1TxN","./Text":"jt9fm","react-aria/useFocusRing":"5qaYX","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"cRr2p":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Provides the behavior and accessibility implementation for a date picker component. A date picker
 * combines a DateField and a Calendar popover to allow users to enter or select a date and time
 * value.
 */ parcelHelpers.export(exports, "useDatePicker", ()=>useDatePicker);
var _focusScope = require("../focus/FocusScope");
var _filterDOMProps = require("../utils/filterDOMProps");
var _json = require("../../intl/datepicker/*.json");
var _jsonDefault = parcelHelpers.interopDefault(_json);
var _mergeProps = require("../utils/mergeProps");
var _domfunctions = require("../utils/shadowdom/DOMFunctions");
var _useFormValidationState = require("react-stately/private/form/useFormValidationState");
var _useDateField = require("./useDateField");
var _useDatePickerGroup = require("./useDatePickerGroup");
var _useDescription = require("../utils/useDescription");
var _useField = require("../label/useField");
var _useFocusWithin = require("../interactions/useFocusWithin");
var _useId = require("../utils/useId");
var _i18Nprovider = require("../i18n/I18nProvider");
var _useLocalizedStringFormatter = require("../i18n/useLocalizedStringFormatter");
var _react = require("react");
function useDatePicker(props, state, ref) {
    let buttonId = (0, _useId.useId)();
    let dialogId = (0, _useId.useId)();
    let fieldId = (0, _useId.useId)();
    let stringFormatter = (0, _useLocalizedStringFormatter.useLocalizedStringFormatter)((0, _jsonDefault.default), '@react-aria/datepicker');
    let { isInvalid, validationErrors, validationDetails } = state.displayValidation;
    let { labelProps, fieldProps, descriptionProps, errorMessageProps } = (0, _useField.useField)({
        ...props,
        labelElementType: 'span',
        isInvalid,
        errorMessage: props.errorMessage || validationErrors
    });
    let groupProps = (0, _useDatePickerGroup.useDatePickerGroup)(state, ref);
    let labelledBy = fieldProps['aria-labelledby'] || fieldProps.id;
    let { locale } = (0, _i18Nprovider.useLocale)();
    let date = state.formatValue(locale, {
        month: 'long'
    });
    let description = date ? stringFormatter.format('selectedDateDescription', {
        date
    }) : '';
    let descProps = (0, _useDescription.useDescription)(description);
    let ariaDescribedBy = [
        descProps['aria-describedby'],
        fieldProps['aria-describedby']
    ].filter(Boolean).join(' ') || undefined;
    let domProps = (0, _filterDOMProps.filterDOMProps)(props);
    let focusManager = (0, _react.useMemo)(()=>(0, _focusScope.createFocusManager)(ref), [
        ref
    ]);
    let isFocused = (0, _react.useRef)(false);
    let { focusWithinProps } = (0, _useFocusWithin.useFocusWithin)({
        ...props,
        isDisabled: state.isOpen,
        onBlurWithin: (e)=>{
            // Ignore when focus moves into the popover.
            let dialog = document.getElementById(dialogId);
            if (!(0, _domfunctions.nodeContains)(dialog, e.relatedTarget)) {
                isFocused.current = false;
                props.onBlur?.(e);
                props.onFocusChange?.(false);
            }
        },
        onFocusWithin: (e)=>{
            if (!isFocused.current) {
                isFocused.current = true;
                props.onFocus?.(e);
                props.onFocusChange?.(true);
            }
        }
    });
    return {
        groupProps: (0, _mergeProps.mergeProps)(domProps, groupProps, fieldProps, descProps, focusWithinProps, {
            role: 'group',
            'aria-disabled': props.isDisabled || null,
            'aria-labelledby': labelledBy,
            'aria-describedby': ariaDescribedBy,
            onKeyDown (e) {
                if (state.isOpen) return;
                if (props.onKeyDown) props.onKeyDown(e);
            },
            onKeyUp (e) {
                if (state.isOpen) return;
                if (props.onKeyUp) props.onKeyUp(e);
            }
        }),
        labelProps: {
            ...labelProps,
            onClick: ()=>{
                focusManager.focusFirst();
            }
        },
        fieldProps: {
            ...fieldProps,
            id: fieldId,
            [(0, _useDateField.roleSymbol)]: 'presentation',
            'aria-describedby': ariaDescribedBy,
            value: state.value,
            defaultValue: state.defaultValue,
            onChange: state.setValue,
            placeholderValue: props.placeholderValue,
            hideTimeZone: props.hideTimeZone,
            hourCycle: props.hourCycle,
            shouldForceLeadingZeros: props.shouldForceLeadingZeros,
            granularity: props.granularity,
            isDisabled: props.isDisabled,
            isReadOnly: props.isReadOnly,
            isRequired: props.isRequired,
            validationBehavior: props.validationBehavior,
            // DatePicker owns the validation state for the date field.
            [(0, _useFormValidationState.privateValidationStateProp)]: state,
            autoFocus: props.autoFocus,
            name: props.name,
            form: props.form
        },
        descriptionProps,
        errorMessageProps,
        buttonProps: {
            ...descProps,
            id: buttonId,
            'aria-haspopup': 'dialog',
            'aria-label': stringFormatter.format('calendar'),
            'aria-labelledby': `${buttonId} ${labelledBy}`,
            'aria-describedby': ariaDescribedBy,
            'aria-expanded': state.isOpen,
            isDisabled: props.isDisabled || props.isReadOnly,
            onPress: ()=>state.setOpen(true)
        },
        dialogProps: {
            id: dialogId,
            'aria-labelledby': `${buttonId} ${labelledBy}`
        },
        calendarProps: {
            autoFocus: true,
            value: state.dateValue,
            onChange: state.setDateValue,
            minValue: props.minValue,
            maxValue: props.maxValue,
            isDisabled: props.isDisabled,
            isReadOnly: props.isReadOnly,
            isDateUnavailable: props.isDateUnavailable,
            defaultFocusedValue: state.dateValue ? undefined : props.placeholderValue,
            isInvalid: state.isInvalid,
            errorMessage: typeof props.errorMessage === 'function' ? props.errorMessage(state.displayValidation) : props.errorMessage || state.displayValidation.validationErrors.join(' '),
            firstDayOfWeek: props.firstDayOfWeek,
            pageBehavior: props.pageBehavior
        },
        isInvalid,
        validationErrors,
        validationDetails
    };
}

},{"../focus/FocusScope":"fNgMQ","../utils/filterDOMProps":"c0Owd","../../intl/datepicker/*.json":"l6ZzN","../utils/mergeProps":"1CzGd","../utils/shadowdom/DOMFunctions":"93ERU","react-stately/private/form/useFormValidationState":"1Dmi5","./useDateField":"5ZZ8R","./useDatePickerGroup":"6zc6L","../utils/useDescription":"3ThWR","../label/useField":"1B1oA","../interactions/useFocusWithin":"lT0uI","../utils/useId":"de3v3","../i18n/I18nProvider":"l34Wn","../i18n/useLocalizedStringFormatter":"4LM0k","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"bYH2k":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Provides the behavior and accessibility implementation for a date picker component.
 * A date range picker combines two DateFields and a RangeCalendar popover to allow
 * users to enter or select a date and time range.
 */ parcelHelpers.export(exports, "useDateRangePicker", ()=>useDateRangePicker);
var _focusScope = require("../focus/FocusScope");
var _useFormValidationState = require("react-stately/private/form/useFormValidationState");
var _filterDOMProps = require("../utils/filterDOMProps");
var _useDateField = require("./useDateField");
var _json = require("../../intl/datepicker/*.json");
var _jsonDefault = parcelHelpers.interopDefault(_json);
var _mergeProps = require("../utils/mergeProps");
var _domfunctions = require("../utils/shadowdom/DOMFunctions");
var _useDatePickerGroup = require("./useDatePickerGroup");
var _useDescription = require("../utils/useDescription");
var _useField = require("../label/useField");
var _useFocusWithin = require("../interactions/useFocusWithin");
var _useId = require("../utils/useId");
var _i18Nprovider = require("../i18n/I18nProvider");
var _useLocalizedStringFormatter = require("../i18n/useLocalizedStringFormatter");
var _react = require("react");
function useDateRangePicker(props, state, ref) {
    let stringFormatter = (0, _useLocalizedStringFormatter.useLocalizedStringFormatter)((0, _jsonDefault.default), '@react-aria/datepicker');
    let { isInvalid, validationErrors, validationDetails } = state.displayValidation;
    let { labelProps, fieldProps, descriptionProps, errorMessageProps } = (0, _useField.useField)({
        ...props,
        labelElementType: 'span',
        isInvalid,
        errorMessage: props.errorMessage || validationErrors
    });
    let labelledBy = fieldProps['aria-labelledby'] || fieldProps.id;
    let { locale } = (0, _i18Nprovider.useLocale)();
    let range = state.formatValue(locale, {
        month: 'long'
    });
    let description = range ? stringFormatter.format('selectedRangeDescription', {
        startDate: range.start,
        endDate: range.end
    }) : '';
    let descProps = (0, _useDescription.useDescription)(description);
    let startFieldProps = {
        'aria-label': stringFormatter.format('startDate'),
        'aria-labelledby': labelledBy
    };
    let endFieldProps = {
        'aria-label': stringFormatter.format('endDate'),
        'aria-labelledby': labelledBy
    };
    let buttonId = (0, _useId.useId)();
    let dialogId = (0, _useId.useId)();
    let groupProps = (0, _useDatePickerGroup.useDatePickerGroup)(state, ref);
    let ariaDescribedBy = [
        descProps['aria-describedby'],
        fieldProps['aria-describedby']
    ].filter(Boolean).join(' ') || undefined;
    let focusManager = (0, _react.useMemo)(()=>(0, _focusScope.createFocusManager)(ref, {
            // Exclude the button from the focus manager.
            accept: (element)=>element.id !== buttonId
        }), [
        ref,
        buttonId
    ]);
    let commonFieldProps = {
        [(0, _useDateField.focusManagerSymbol)]: focusManager,
        [(0, _useDateField.roleSymbol)]: 'presentation',
        'aria-describedby': ariaDescribedBy,
        placeholderValue: props.placeholderValue,
        hideTimeZone: props.hideTimeZone,
        hourCycle: props.hourCycle,
        granularity: props.granularity,
        shouldForceLeadingZeros: props.shouldForceLeadingZeros,
        isDisabled: props.isDisabled,
        isReadOnly: props.isReadOnly,
        isRequired: props.isRequired,
        validationBehavior: props.validationBehavior
    };
    let domProps = (0, _filterDOMProps.filterDOMProps)(props);
    let isFocused = (0, _react.useRef)(false);
    let { focusWithinProps } = (0, _useFocusWithin.useFocusWithin)({
        ...props,
        isDisabled: state.isOpen,
        onBlurWithin: (e)=>{
            // Ignore when focus moves into the popover.
            let dialog = document.getElementById(dialogId);
            if (!(0, _domfunctions.nodeContains)(dialog, e.relatedTarget)) {
                isFocused.current = false;
                props.onBlur?.(e);
                props.onFocusChange?.(false);
            }
        },
        onFocusWithin: (e)=>{
            if (!isFocused.current) {
                isFocused.current = true;
                props.onFocus?.(e);
                props.onFocusChange?.(true);
            }
        }
    });
    let startFieldValidation = (0, _react.useRef)((0, _useFormValidationState.DEFAULT_VALIDATION_RESULT));
    let endFieldValidation = (0, _react.useRef)((0, _useFormValidationState.DEFAULT_VALIDATION_RESULT));
    return {
        groupProps: (0, _mergeProps.mergeProps)(domProps, groupProps, fieldProps, descProps, focusWithinProps, {
            role: 'group',
            'aria-disabled': props.isDisabled || null,
            'aria-describedby': ariaDescribedBy,
            onKeyDown (e) {
                if (state.isOpen) return;
                if (props.onKeyDown) props.onKeyDown(e);
            },
            onKeyUp (e) {
                if (state.isOpen) return;
                if (props.onKeyUp) props.onKeyUp(e);
            }
        }),
        labelProps: {
            ...labelProps,
            onClick: ()=>{
                focusManager.focusFirst();
            }
        },
        buttonProps: {
            ...descProps,
            id: buttonId,
            'aria-haspopup': 'dialog',
            'aria-label': stringFormatter.format('calendar'),
            'aria-labelledby': `${buttonId} ${labelledBy}`,
            'aria-describedby': ariaDescribedBy,
            'aria-expanded': state.isOpen,
            isDisabled: props.isDisabled || props.isReadOnly,
            onPress: ()=>state.setOpen(true)
        },
        dialogProps: {
            id: dialogId,
            'aria-labelledby': `${buttonId} ${labelledBy}`
        },
        startFieldProps: {
            ...startFieldProps,
            ...commonFieldProps,
            value: state.value?.start ?? null,
            defaultValue: state.defaultValue?.start,
            onChange: (start)=>state.setDateTime('start', start),
            autoFocus: props.autoFocus,
            name: props.startName,
            form: props.form,
            [(0, _useFormValidationState.privateValidationStateProp)]: {
                realtimeValidation: state.realtimeValidation,
                displayValidation: state.displayValidation,
                updateValidation (e) {
                    startFieldValidation.current = e;
                    state.updateValidation((0, _useFormValidationState.mergeValidation)(e, endFieldValidation.current));
                },
                resetValidation: state.resetValidation,
                commitValidation: state.commitValidation
            }
        },
        endFieldProps: {
            ...endFieldProps,
            ...commonFieldProps,
            value: state.value?.end ?? null,
            defaultValue: state.defaultValue?.end,
            onChange: (end)=>state.setDateTime('end', end),
            name: props.endName,
            form: props.form,
            [(0, _useFormValidationState.privateValidationStateProp)]: {
                realtimeValidation: state.realtimeValidation,
                displayValidation: state.displayValidation,
                updateValidation (e) {
                    endFieldValidation.current = e;
                    state.updateValidation((0, _useFormValidationState.mergeValidation)(startFieldValidation.current, e));
                },
                resetValidation: state.resetValidation,
                commitValidation: state.commitValidation
            }
        },
        descriptionProps,
        errorMessageProps,
        calendarProps: {
            autoFocus: true,
            value: state.dateRange?.start && state.dateRange.end ? state.dateRange : null,
            onChange: state.setDateRange,
            minValue: props.minValue,
            maxValue: props.maxValue,
            isDisabled: props.isDisabled,
            isReadOnly: props.isReadOnly,
            isDateUnavailable: props.isDateUnavailable,
            allowsNonContiguousRanges: props.allowsNonContiguousRanges,
            defaultFocusedValue: state.dateRange ? undefined : props.placeholderValue,
            isInvalid: state.isInvalid,
            errorMessage: typeof props.errorMessage === 'function' ? props.errorMessage(state.displayValidation) : props.errorMessage || state.displayValidation.validationErrors.join(' '),
            firstDayOfWeek: props.firstDayOfWeek,
            pageBehavior: props.pageBehavior
        },
        isInvalid,
        validationErrors,
        validationDetails
    };
}

},{"../focus/FocusScope":"fNgMQ","react-stately/private/form/useFormValidationState":"1Dmi5","../utils/filterDOMProps":"c0Owd","./useDateField":"5ZZ8R","../../intl/datepicker/*.json":"l6ZzN","../utils/mergeProps":"1CzGd","../utils/shadowdom/DOMFunctions":"93ERU","./useDatePickerGroup":"6zc6L","../utils/useDescription":"3ThWR","../label/useField":"1B1oA","../interactions/useFocusWithin":"lT0uI","../utils/useId":"de3v3","../i18n/I18nProvider":"l34Wn","../i18n/useLocalizedStringFormatter":"4LM0k","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"leLOt":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Provides state management for a date picker component. A date picker combines a DateField and a
 * Calendar popover to allow users to enter or select a date and time value.
 */ parcelHelpers.export(exports, "useDatePickerState", ()=>useDatePickerState);
var _date = require("@internationalized/date");
var _utils = require("./utils");
var _useFormValidationState = require("../form/useFormValidationState");
var _useOverlayTriggerState = require("../overlays/useOverlayTriggerState");
var _useControlledState = require("../utils/useControlledState");
var _react = require("react");
function useDatePickerState(props) {
    let overlayState = (0, _useOverlayTriggerState.useOverlayTriggerState)(props);
    let [value, setValue] = (0, _useControlledState.useControlledState)(props.value, props.defaultValue || null, props.onChange);
    let [initialValue] = (0, _react.useState)(value);
    let v = value || props.placeholderValue || null;
    let [granularity, defaultTimeZone] = (0, _utils.useDefaultProps)(v, props.granularity);
    let dateValue = value != null ? value.toDate(defaultTimeZone ?? 'UTC') : null;
    let hasTime = granularity === 'hour' || granularity === 'minute' || granularity === 'second';
    let shouldCloseOnSelect = props.shouldCloseOnSelect ?? true;
    let [selectedDate, setSelectedDate] = (0, _react.useState)(null);
    let [selectedTime, setSelectedTime] = (0, _react.useState)(null);
    if (value) {
        selectedDate = value;
        if ('hour' in value) selectedTime = value;
    }
    // props.granularity must actually exist in the value if one is provided.
    if (v && !(granularity in v)) throw new Error('Invalid granularity ' + granularity + ' for value ' + v.toString());
    let showEra = value?.calendar.identifier === 'gregory' && value.era === 'BC';
    let formatOpts = (0, _react.useMemo)(()=>({
            granularity,
            timeZone: defaultTimeZone,
            hideTimeZone: props.hideTimeZone,
            hourCycle: props.hourCycle,
            shouldForceLeadingZeros: props.shouldForceLeadingZeros,
            showEra
        }), [
        granularity,
        props.hourCycle,
        props.shouldForceLeadingZeros,
        defaultTimeZone,
        props.hideTimeZone,
        showEra
    ]);
    let { minValue, maxValue, isDateUnavailable } = props;
    let builtinValidation = (0, _react.useMemo)(()=>(0, _utils.getValidationResult)(value, minValue, maxValue, isDateUnavailable, formatOpts), [
        value,
        minValue,
        maxValue,
        isDateUnavailable,
        formatOpts
    ]);
    let validation = (0, _useFormValidationState.useFormValidationState)({
        ...props,
        value: value,
        builtinValidation
    });
    let isValueInvalid = validation.displayValidation.isInvalid;
    let validationState = props.validationState || (isValueInvalid ? 'invalid' : null);
    let commitValue = (date, time)=>{
        setValue('timeZone' in time ? time.set((0, _date.toCalendarDate)(date)) : (0, _date.toCalendarDateTime)(date, time));
        setSelectedDate(null);
        setSelectedTime(null);
        validation.commitValidation();
    };
    // Intercept setValue to make sure the Time section is not changed by date selection in Calendar
    let selectDate = (newValue)=>{
        let shouldClose = typeof shouldCloseOnSelect === 'function' ? shouldCloseOnSelect() : shouldCloseOnSelect;
        if (hasTime) {
            if (selectedTime || shouldClose) commitValue(newValue, selectedTime || (0, _utils.getPlaceholderTime)(props.defaultValue || props.placeholderValue));
            else setSelectedDate(newValue);
        } else {
            setValue(newValue);
            validation.commitValidation();
        }
        if (shouldClose) overlayState.setOpen(false);
    };
    let selectTime = (newValue)=>{
        if (selectedDate && newValue) commitValue(selectedDate, newValue);
        else setSelectedTime(newValue);
    };
    return {
        ...validation,
        value,
        defaultValue: props.defaultValue ?? initialValue,
        setValue,
        dateValue: selectedDate,
        timeValue: selectedTime,
        setDateValue: selectDate,
        setTimeValue: selectTime,
        granularity,
        hasTime,
        ...overlayState,
        setOpen (isOpen) {
            // Commit the selected date when the calendar is closed. Use a placeholder time if one wasn't set.
            // If only the time was set and not the date, don't commit. The state will be preserved until
            // the user opens the popover again.
            if (!isOpen && !value && selectedDate && hasTime) commitValue(selectedDate, selectedTime || (0, _utils.getPlaceholderTime)(props.defaultValue || props.placeholderValue));
            overlayState.setOpen(isOpen);
        },
        validationState,
        isInvalid: isValueInvalid,
        formatValue (locale, fieldOptions) {
            if (!dateValue) return '';
            let formatOptions = (0, _utils.getFormatOptions)(fieldOptions, formatOpts);
            let formatter = new (0, _date.DateFormatter)(locale, formatOptions);
            return formatter.format(dateValue);
        },
        getDateFormatter (locale, formatOptions) {
            let newOptions = {
                ...formatOpts,
                ...formatOptions
            };
            let newFormatOptions = (0, _utils.getFormatOptions)({}, newOptions);
            return new (0, _date.DateFormatter)(locale, newFormatOptions);
        }
    };
}

},{"@internationalized/date":[["DateFormatter","6ueXY"],["toCalendarDate","bwoxj"],["toCalendarDateTime","bwoxj"]],"./utils":"5Z4re","../form/useFormValidationState":"1Dmi5","../overlays/useOverlayTriggerState":"4NIpq","../utils/useControlledState":"iZt2P","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"iJMKi":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Provides state management for a date range picker component.
 * A date range picker combines two DateFields and a RangeCalendar popover to allow
 * users to enter or select a date and time range.
 */ parcelHelpers.export(exports, "useDateRangePickerState", ()=>useDateRangePickerState);
var _date = require("@internationalized/date");
var _utils = require("./utils");
var _useFormValidationState = require("../form/useFormValidationState");
var _useOverlayTriggerState = require("../overlays/useOverlayTriggerState");
var _useControlledState = require("../utils/useControlledState");
var _react = require("react");
function useDateRangePickerState(props) {
    let overlayState = (0, _useOverlayTriggerState.useOverlayTriggerState)(props);
    let [controlledValue, setControlledValue] = (0, _useControlledState.useControlledState)(props.value, props.defaultValue || null, props.onChange);
    let [initialValue] = (0, _react.useState)(controlledValue);
    let [placeholderValue, setPlaceholderValue] = (0, _react.useState)(()=>controlledValue || {
            start: null,
            end: null
        });
    // Reset the placeholder if the value prop is set to null.
    if (controlledValue == null && placeholderValue.start && placeholderValue.end) {
        placeholderValue = {
            start: null,
            end: null
        };
        setPlaceholderValue(placeholderValue);
    }
    let value = controlledValue || placeholderValue;
    let setValue = (newValue)=>{
        // oxlint-disable-next-line react/react-compiler
        value = newValue || {
            start: null,
            end: null
        };
        setPlaceholderValue(value);
        if (isCompleteRange(value)) setControlledValue(value);
        else setControlledValue(null);
    };
    let v = value?.start || value?.end || props.placeholderValue || null;
    let [granularity, defaultTimeZone] = (0, _utils.useDefaultProps)(v, props.granularity);
    let hasTime = granularity === 'hour' || granularity === 'minute' || granularity === 'second';
    let shouldCloseOnSelect = props.shouldCloseOnSelect ?? true;
    let [dateRange, setSelectedDateRange] = (0, _react.useState)(null);
    let [timeRange, setSelectedTimeRange] = (0, _react.useState)(null);
    if (value && isCompleteRange(value)) {
        dateRange = value;
        if ('hour' in value.start) timeRange = value;
    }
    let commitValue = (dateRange, timeRange)=>{
        setValue({
            start: 'timeZone' in timeRange.start ? timeRange.start.set((0, _date.toCalendarDate)(dateRange.start)) : (0, _date.toCalendarDateTime)(dateRange.start, timeRange.start),
            end: 'timeZone' in timeRange.end ? timeRange.end.set((0, _date.toCalendarDate)(dateRange.end)) : (0, _date.toCalendarDateTime)(dateRange.end, timeRange.end)
        });
        setSelectedDateRange(null);
        setSelectedTimeRange(null);
        validation.commitValidation();
    };
    // Intercept setValue to make sure the Time section is not changed by date selection in Calendar
    let setDateRange = (range)=>{
        let shouldClose = typeof shouldCloseOnSelect === 'function' ? shouldCloseOnSelect() : shouldCloseOnSelect;
        if (hasTime) {
            // Set a placeholder time if the popover is closing so we don't leave the field in an incomplete state.
            if (isCompleteRange(range) && (shouldClose || timeRange?.start && timeRange?.end)) commitValue(range, {
                start: timeRange?.start || (0, _utils.getPlaceholderTime)(props.placeholderValue),
                end: timeRange?.end || (0, _utils.getPlaceholderTime)(props.placeholderValue)
            });
            else setSelectedDateRange(range);
        } else if (isCompleteRange(range)) {
            setValue(range);
            validation.commitValidation();
        } else setSelectedDateRange(range);
        if (shouldClose) overlayState.setOpen(false);
    };
    let setTimeRange = (range)=>{
        if (isCompleteRange(dateRange) && isCompleteRange(range)) commitValue(dateRange, range);
        else setSelectedTimeRange(range);
    };
    let showEra = value?.start?.calendar.identifier === 'gregory' && value.start.era === 'BC' || value?.end?.calendar.identifier === 'gregory' && value.end.era === 'BC';
    let formatOpts = (0, _react.useMemo)(()=>({
            granularity,
            timeZone: defaultTimeZone,
            hideTimeZone: props.hideTimeZone,
            hourCycle: props.hourCycle,
            shouldForceLeadingZeros: props.shouldForceLeadingZeros,
            showEra
        }), [
        granularity,
        props.hourCycle,
        props.shouldForceLeadingZeros,
        defaultTimeZone,
        props.hideTimeZone,
        showEra
    ]);
    let { minValue, maxValue, isDateUnavailable } = props;
    let builtinValidation = (0, _react.useMemo)(()=>(0, _utils.getRangeValidationResult)(value, minValue, maxValue, isDateUnavailable ? (date)=>isDateUnavailable(date, null) : undefined, formatOpts), [
        value,
        minValue,
        maxValue,
        isDateUnavailable,
        formatOpts
    ]);
    let validation = (0, _useFormValidationState.useFormValidationState)({
        ...props,
        value: controlledValue,
        name: (0, _react.useMemo)(()=>[
                props.startName,
                props.endName
            ].filter((n)=>n != null), [
            props.startName,
            props.endName
        ]),
        builtinValidation
    });
    let isValueInvalid = validation.displayValidation.isInvalid;
    let validationState = props.validationState || (isValueInvalid ? 'invalid' : null);
    return {
        ...validation,
        value,
        defaultValue: props.defaultValue ?? initialValue,
        setValue,
        dateRange,
        timeRange,
        granularity,
        hasTime,
        setDate (part, date) {
            if (part === 'start') setDateRange({
                start: date,
                end: dateRange?.end ?? null
            });
            else setDateRange({
                start: dateRange?.start ?? null,
                end: date
            });
        },
        setTime (part, time) {
            if (part === 'start') setTimeRange({
                start: time,
                end: timeRange?.end ?? null
            });
            else setTimeRange({
                start: timeRange?.start ?? null,
                end: time
            });
        },
        setDateTime (part, dateTime) {
            if (part === 'start') setValue({
                start: dateTime,
                end: value?.end ?? null
            });
            else setValue({
                start: value?.start ?? null,
                end: dateTime
            });
        },
        setDateRange,
        setTimeRange,
        ...overlayState,
        setOpen (isOpen) {
            // Commit the selected date range when the calendar is closed. Use a placeholder time if one wasn't set.
            // If only the time range was set and not the date range, don't commit. The state will be preserved until
            // the user opens the popover again.
            if (!isOpen && !(value?.start && value?.end) && isCompleteRange(dateRange) && hasTime) commitValue(dateRange, {
                start: timeRange?.start || (0, _utils.getPlaceholderTime)(props.placeholderValue),
                end: timeRange?.end || (0, _utils.getPlaceholderTime)(props.placeholderValue)
            });
            overlayState.setOpen(isOpen);
        },
        validationState,
        isInvalid: isValueInvalid,
        formatValue (locale, fieldOptions) {
            if (!value || !value.start || !value.end) return null;
            let startTimeZone = 'timeZone' in value.start ? value.start.timeZone : undefined;
            let startGranularity = props.granularity || (value.start && 'minute' in value.start ? 'minute' : 'day');
            let endTimeZone = 'timeZone' in value.end ? value.end.timeZone : undefined;
            let endGranularity = props.granularity || (value.end && 'minute' in value.end ? 'minute' : 'day');
            let startOptions = (0, _utils.getFormatOptions)(fieldOptions, {
                granularity: startGranularity,
                timeZone: startTimeZone,
                hideTimeZone: props.hideTimeZone,
                hourCycle: props.hourCycle,
                showEra: value.start.calendar.identifier === 'gregory' && value.start.era === 'BC' || value.end.calendar.identifier === 'gregory' && value.end.era === 'BC'
            });
            let startDate = value.start.toDate(startTimeZone || 'UTC');
            let endDate = value.end.toDate(endTimeZone || 'UTC');
            let startFormatter = new (0, _date.DateFormatter)(locale, startOptions);
            let endFormatter;
            if (startTimeZone === endTimeZone && startGranularity === endGranularity && value.start.compare(value.end) !== 0) {
                // Use formatRange, as it results in shorter output when some of the fields
                // are shared between the start and end dates (e.g. the same month).
                // Formatting will fail if the end date is before the start date. Fall back below when that happens.
                try {
                    let parts = startFormatter.formatRangeToParts(startDate, endDate);
                    // Find the separator between the start and end date. This is determined
                    // by finding the last shared literal before the end range.
                    let separatorIndex = -1;
                    for(let i = 0; i < parts.length; i++){
                        let part = parts[i];
                        if (part.source === 'shared' && part.type === 'literal') separatorIndex = i;
                        else if (part.source === 'endRange') break;
                    }
                    // Now we can combine the parts into start and end strings.
                    let start = '';
                    let end = '';
                    for(let i = 0; i < parts.length; i++){
                        if (i < separatorIndex) start += parts[i].value;
                        else if (i > separatorIndex) end += parts[i].value;
                    }
                    return {
                        start,
                        end
                    };
                } catch  {
                // ignore
                }
                endFormatter = startFormatter;
            } else {
                let endOptions = (0, _utils.getFormatOptions)(fieldOptions, {
                    granularity: endGranularity,
                    timeZone: endTimeZone,
                    hideTimeZone: props.hideTimeZone,
                    hourCycle: props.hourCycle
                });
                endFormatter = new (0, _date.DateFormatter)(locale, endOptions);
            }
            return {
                start: startFormatter.format(startDate),
                end: endFormatter.format(endDate)
            };
        },
        getDateFormatter (locale, formatOptions) {
            let newOptions = {
                ...formatOpts,
                ...formatOptions
            };
            let newFormatOptions = (0, _utils.getFormatOptions)({}, newOptions);
            return new (0, _date.DateFormatter)(locale, newFormatOptions);
        }
    };
}
function isCompleteRange(value) {
    return value?.start != null && value.end != null;
}

},{"@internationalized/date":[["DateFormatter","6ueXY"],["toCalendarDate","bwoxj"],["toCalendarDateTime","bwoxj"]],"./utils":"5Z4re","../form/useFormValidationState":"1Dmi5","../overlays/useOverlayTriggerState":"4NIpq","../utils/useControlledState":"iZt2P","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}]},[], null, "parcelRequire7f0c", {})

//# sourceMappingURL=ButtonGroup.b58be200.js.map
